import { render, staticRenderFns } from "./ShipmentSizes.vue?vue&type=template&id=1282959f&"
import script from "./ShipmentSizes.vue?vue&type=script&lang=js&"
export * from "./ShipmentSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports